import { useEffect, useState } from "react";
import Header from "./common/components/header/header";
import Section1 from "./common/modules/app/components/section1";
import Section2 from "./common/modules/app/components/section2";
import Section3 from "./common/modules/app/components/section3";
import Section4 from "./common/modules/app/components/section4";
import Section5 from "./common/modules/app/components/section5";
import MobileMenu from "./common/components/header/mobile";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    if (isOpen) {
        document.body.classList.add("overflow-hidden");
    } else {
        document.body.classList.remove("overflow-hidden");
    }
}, [isOpen]);
  return (
    <div className={`flex flex-col overflow-hidden`}>
      <Header
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
       />
      <MobileMenu
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
      />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </div>
  );
}

export default App;
